import React from "react";
import "../../OtherPages.scss";

const OtherPagesStyles = () => <>
{/* <div className="lol"></div> */}
</>;

export default OtherPagesStyles;
